import NavBar from "../components/navBar";
import Footer from "../components/footer";
import { useCart } from "../components/cart/cartProvider";
import LinkComponent from "../components/link";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../static/css/cartPage.css';
import PaymentModal from "../components/payment/paymenModal";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import DeliveryDatePicker from "../components/deliveryDatePicker";
import { validateAddress, deliveryAreaCheck, calculateDeliveryPrice } from "../api/mapAPI"
import { set } from "date-fns";

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const REACT_APP_MEDIA_URL = process.env.REACT_APP_MEDIA_URL;
const REACT_APP_BACKEND_API_KEY = process.env.REACT_APP_BACKEND_API_KEY;

function CartSection() {
    const location = useLocation();
    const [errorMessage, setErrorMessage] = useState(location.state?.args?.error?location.state?.arg?.category:null);
    const [clientSecret, setClientSecret] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const { addToCart, cartItems, removeFromCart } = useCart();
    const [email, setEmail] = useState();
    const [addressLine1, setAddressLine1] = useState("");
    const [addressLine2, setAddressLine2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [zip, setZip] = useState("");
    const [phone, setPhone] = useState("");
    const [deliveryFee, setDeliveryFee] = useState(0);
    const [deliverable, setDeliverable] = useState(true);
    const [deliveryDate, setDeliveryDate] = useState(null);
    const [showInfo, setShowInfo] = useState(false);
    const [deliveryToggle, setDeliveryToggle] = useState(false);


    const handleDeliveryDateChange = (date) => {
        setDeliveryDate(date);
    };

    const runAddressFunction = addressLine1 && city && state && zip;

    useEffect(()=>{
        const fetchDeliveryInfo = async () => {
            if (runAddressFunction) {
                const address = `${addressLine1},${addressLine2},${city},${state},${zip}`;
                try {
                    // Wait for both address validation and delivery area check to complete
                    const addressValid = await validateAddress(address); 
                    const areaValid = await deliveryAreaCheck(address);
                    if (addressValid.valid && areaValid.valid) {
                        setDeliverable(true);
                        const deliveryPrice = await calculateDeliveryPrice(address);
                        setDeliveryFee(deliveryPrice.price);
                        console.log("delivery price set");
                    } else {
                        setDeliverable(false);
                        console.log("Undeliverable");
                    }
                } catch (error) {
                    console.log(error);
                    setDeliverable(false);
                }
            } else {
                setDeliverable(true)
            }
        };
        fetchDeliveryInfo();
    },[addressLine1,city,state,zip]);

    const fetchClientSecret = async (amount) => {
        const response = await fetch(`${REACT_APP_BACKEND_URL}create-payment-intent`, {
            method: "POST",
            headers: { "Content-Type": "application/json","x-api-key": REACT_APP_BACKEND_API_KEY },
            body: JSON.stringify({ amount: parseFloat(amount)*100, description: JSON.stringify(cartItems.map(product => product.productID)) }),
        });
        const { clientSecret } = await response.json();
        setClientSecret(clientSecret);
    };

    const handleCheckoutClick = async () => {
        setShowInfo(true);
    };
    
    const calculateTotal = () => {
        return cartItems.reduce((total, product) => {
            return total + (product.quantity * product.Price + product.addOns.reduce((sum, addon) => sum + addon.Price, 0));
        }, 0).toFixed(2);
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const error = params.get('error');
        if (error) {
            setErrorMessage(decodeURIComponent(error));
        }
    }, [location]);

    const sub_total=calculateTotal();
    const tax=(sub_total*0.0825).toFixed(2);
    const processing_fee = (sub_total*0.03).toFixed(2);
    const total = (parseFloat(tax)+parseFloat(sub_total)+deliveryFee+parseFloat(processing_fee)).toFixed(2);

    const handleInfoSubmit = async (event) => {
        event.preventDefault();
        if (deliveryToggle && (!email || !addressLine1 || !city || !state || !zip || !phone)) {
            alert("Please fill in all required fields.");
            return;
        }
        if (!deliverable) {
            alert("Your location is incorrect or out of bounds. (Delivery is only available in certain areas around houston. If you believe this is a mistake, send us an email at sweetwoodflora@gmail.com.")
            return;
        }
        await fetchClientSecret(total);
        setShowInfo(false);
        setShowModal(true);
    }

    const handleDeliveryToggle = (event) => {
        setDeliveryToggle(event.target.checked);
    }

    useEffect(()=> {
        if(!deliveryToggle) {
            setAddressLine1("")
            setAddressLine2("")
            setCity("")
            setState("")
            setZip("")
            setDeliveryFee(0)
        }
    },[deliveryToggle]);

    if (cartItems.length<=0) {
        return (
            <div className="container justify-content-center align-items-center d-flex flex-column" style={{height: "90vh"}}>
                <h1 className="text-light mt-5" style={{fontSize: "clamp(3rem, 5vw, 5rem)"}}>
                    Shopping Cart
                </h1>
                <h2 className="text-light mb-5">Doesn't seem like you added anything to the cart.</h2>
                <LinkComponent link={"/inventory"} component={<button className="btn btn-dark my-3" style={{fontSize: "clamp(1rem, 5vw, 2rem)"}}>Continue Shopping</button>}/>
            </div>
        );
    }
    else {
        return (
            <div className="container align-items-center d-flex flex-column my-5" style={{flex: "1", minHeight: "90vh"}}>
                <h1 className="text-light mt-5" style={{fontSize: "clamp(3rem, 5vw, 5rem)"}}>
                    Shopping Cart
                </h1>
                <table className="table">
                    <tbody style={{fontSize: "clamp(1rem, 1vw, 1.8rem)"}}>
                        {cartItems.map((product, index) => {
                            return(<tr key={index}>
                                <th className="text-start" style={{verticalAlign: "middle"}} scope="row">{index+1}</th>
                                <td className="text-center"><img className="m-auto p-0" src={`${REACT_APP_MEDIA_URL}${product.productImage[0]?.url}`} alt={product.title} style={{height: "15vh", objectFit: "cover"}} /></td>
                                <td className="text-center" style={{verticalAlign: "middle"}}>{product.title}</td>
                                <td className="text-center" style={{verticalAlign: "middle"}}>{product.quantity}</td>
                                <td className="text-center" style={{verticalAlign: "middle"}}>$ {(product.quantity * product.Price + product.addOns.reduce((sum, addon) => sum + addon.Price, 0)).toFixed(2)}</td>
                                <td className="text-end" style={{verticalAlign: "middle"}}>
                                    <button className="btn btn-dark" onClick={()=>removeFromCart(product.id)}><i className="bi bi-x"/></button>
                                </td>
                            </tr>);
                        })}
                    </tbody>
                </table>
                <div className="container d-flex flex-row justify-content-end">
                    <p className="mx-5 my-auto" style={{fontSize: "clamp(1rem, 2vw, 2rem)", color: "white"}}>Total: ${calculateTotal()}
                    </p>
                    <button className="btn btn-dark" onClick={handleCheckoutClick} style={{fontSize: "clamp(1rem, 2vw, 1.6rem)"}}>Checkout</button>
                </div>
                {showInfo && <form className="container-fluid" onSubmit={handleInfoSubmit} style={{fontSize: "clamp(1em, 2vw, 1.5em)"}}>
                    <div className="d-flex flex-column">
                        <div className="d-flex flex-column rounded bg-secondary-subtle text-dark p-4 m-2 flex-grow-1">
                            <p>Summary</p>
                            <div className="d-flex flex-row">
                                <p className="me-auto">Taxes</p>
                                <p>${tax}</p>
                            </div>
                            <div className="d-flex flex-row">
                                <p className="me-auto">Delivery Fee (Enter Address to show updated fee)</p>
                                <p>${deliveryFee}</p>
                            </div>
                            <div className="d-flex flex-row">
                                <p className="me-auto">Subtotal</p>
                                <p>${sub_total}</p>
                            </div>
                            <div className="d-flex flex-row">
                                <p className="me-auto">Processing Fee</p>
                                <p>${processing_fee}</p>
                            </div>
                            <div className="d-flex flex-row border-top border-dark pt-3">
                                <p className="me-auto">Total</p>
                                <p>${total}</p>
                            </div>
                            {!deliverable && <p style={{color: "red"}}>Sorry Your Address is either incorrect or out of bounds. Please double Check! </p>}
                        </div>
                        <div className="d-flex flex-column flex-sm-row">
                            <div className="d-flex flex-column flex-grow-1 me-3">
                                <label for="email" class="form-label text-dark px-2 py-0 m-0">Email address</label>
                                <input 
                                    className="rounded border-primary form-control"
                                    type="email"
                                    id="email"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="d-flex flex-column flex-grow-1 me-3">
                                <label for="phone" class="form-label text-dark px-2 py-0 m-0">Phone Number</label>
                                <input
                                    className="rounded border-primary form-control"
                                    type="text"
                                    id="phone"
                                    placeholder="phone number"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    required
                                />
                            </div>
                            <DeliveryDatePicker onDateChange={handleDeliveryDateChange} />
                        </div>
                    </div>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={deliveryToggle} onChange={handleDeliveryToggle}/>
                        <label class="form-check-label" for="flexSwitchCheckDefault">{deliveryToggle ? "Deilvery" : "Pickup"}</label>
                    </div>
                    {deliveryToggle && <div><div className="d-flex flex-column">
                        <div className="d-flex flex-row">
                            <div style={{width:"100%"}} className="me-3">
                                <label for="address1" class="form-label text-dark px-2 py-0 m-0">Shipping Address 1</label>
                                <input
                                    className="rounded border-primary form-control"
                                    type="text"
                                    id="address1"
                                    placeholder="Shipping Address 1"
                                    value={addressLine1}
                                    onChange={(e) => setAddressLine1(e.target.value)}
                                    required
                                />
                            </div>
                            <div style={{width:"100%"}} >
                                <label for="address2" class="form-label text-dark px-2 py-0 m-0">Shipping Address 2</label>
                                <input
                                    className="rounded border-primary form-control"
                                    type="text"
                                    id="address2"
                                    placeholder="Shipping Address 2"
                                    value={addressLine2}
                                    onChange={(e) => setAddressLine2(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-row mb-3">
                        <div style={{width:"45%"}} className="me-auto">
                            <label for="city" class="form-label text-dark px-2 py-0 m-0">City</label>
                            <input
                                className="rounded border-primary form-control"
                                type="text"
                                id="city"
                                placeholder="Shipping city"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                                required
                            />
                        </div>
                        <div style={{width:"25%"}} className="me-auto">
                            <label for="state" class="form-label text-dark px-2 py-0 m-0">State</label>
                            <input
                                className="rounded border-primary form-control"
                                type="text"
                                id="state"
                                placeholder="Shipping state"
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                                required
                            />
                        </div>
                        <div style={{width:"25%"}}>   
                            <label for="zip" class="form-label text-dark px-2 py-0 m-0">ZipCode</label>
                            <input
                                className="rounded border-primary form-control"
                                type="text"
                                id="zip"
                                placeholder="Shipping zipcode"
                                value={zip}
                                onChange={(e) => setZip(e.target.value)}
                                required
                            />
                        </div>
                    </div></div>}
                    <div className="w-100 d-flex">
                        <button type="submit" className="btn btn-dark mx-auto">Continue</button>
                    </div>
                </form>}
                <PaymentModal 
                    clientSecret={clientSecret} 
                    show={showModal} 
                    email={email} 
                    addressLine1={addressLine1} 
                    addressLine2={addressLine2} 
                    city={city} state={state} 
                    zip={zip} phone={phone} 
                    deliveryDate={deliveryDate}
                    deliveryToggle={deliveryToggle}/>
                {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                        {errorMessage + "Please Try Again!"}
                    </div>
                )}
            </div>
        );
    }

}

function CartPage() {
    return (
        <div>
            <NavBar/>
            <CartSection/>
            <Footer/>
        </div>
    );
}

export default CartPage;